var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-modal-price-box"},[_c('p',{staticClass:"product-modal-price-box-title"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"product-modal-price-number"},[_vm._v(_vm._s(_vm.number)+" "+_vm._s(_vm.unit))]),_c('span',[_vm._v(_vm._s(_vm.footer))])])
}
var staticRenderFns = []

export { render, staticRenderFns }